import { FilterRule } from './InfluencerList.filterTypes';
import { InfluencerSorting } from './InfluencerList.viewModel.mappers';

const FILTERS_KEY = 'influencerListFilters';
const PRESETS_KEY = 'influencerListFilterPresets';
const USE_OLD_LIST_KEY = 'influencerListUseOldList';

export type StoredFilters = {
  search: string;
  filterRules: FilterRule[];
  sorting: InfluencerSorting;
};

export type FilterPreset = {
  id: string;
  name: string;
  filters: StoredFilters;
};

const read = <T>(key: string, fallback: T): T => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;

    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};

const write = (key: string, value: unknown): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    return;
  }
};

export const loadFilters = (): Partial<StoredFilters> => read(FILTERS_KEY, {});

export const saveFilters = (filters: StoredFilters): void =>
  write(FILTERS_KEY, filters);

export const loadFilterPresets = (): FilterPreset[] => read(PRESETS_KEY, []);

export const saveFilterPresets = (presets: FilterPreset[]): void =>
  write(PRESETS_KEY, presets);

export const loadUseOldList = (): boolean =>
  read<unknown>(USE_OLD_LIST_KEY, false) === true;

export const saveUseOldList = (useOldList: boolean): void =>
  write(USE_OLD_LIST_KEY, useOldList);
